export const MixpanelLocation = {
    Insight: "Insight",
    Policies: "Policies",
    Report: "Report",
    TenantInfo: "Tenant Info",
    UserDetails: "User Details",
    WorkspaceDetails: "Workspace Details"
} as const;

export type MixpanelLocation = (typeof MixpanelLocation)[keyof typeof MixpanelLocation];

export const MixpanelSublocation = {
    ActivityLog: "Activity Log",
    AiGenerated: "AI generated",
    ContentCentric: "Content centric",
    GroupCentric: "Group centric",
    GroupMembership: "Group Membership",
    Groups: "Groups",
    Libraries: "Libraries",
    Licenses: "Licenses",
    Manual: "Manual",
    Overview: "Overview",
    SavedReports: "Saved reports",
    SharedLinks: "Shared Links",
    SharingLinks: "Sharing Links",
    SitePermissions: "Site Permissions",
    Template: "Template",
    UserCentric: "User centric",
    UserPermissions: "Permissions"
} as const;

export type MixpanelSublocation = (typeof MixpanelSublocation)[keyof typeof MixpanelSublocation];
